<template>
  <div class="websocket--container">
    <transition name="slide-fade">
      <div v-if="showSuccess" class="websocket--success status-done">
        Соединение установлено
      </div>
      <div v-if="showDanger" class="websocket--danger status-new">
        Отсутствует соединение
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import config from "@/config";
import userRepository from "../repositories/user";
import websocketEventBus from "../eventBus/websocketEventBus";
import Formatter from "../components/libraries/Formatter";
import LoggerLibrary from "@/components/libraries/LoggerLibrary";

const formatter = new Formatter();

export default {
  name: "Websocket",
  data() {
    return {
      userId: null,
      showSuccess: false,
      showDanger: false,
      closeConnectTime: 0,
    }
  },
  computed: {
    ...mapState({
      isShow: state => state.preloader.isShow,
      lastLeaveTime: state => state.app_leave.last_leave_time
    }),
    // используем настройку, чтобы переставать реагировать на события websocket
    leaveForImitationEvents() {
      return config.app_leave_for_imitation_events_minutes * 60 * 1000;
    },
  },
  methods: {
    getDatePhp() {
      return formatter.jsObjectToPhp(new Date());
    },
    tooLongDisconnect(time) {
      const timeDifference = new Date().getTime() - time;
      const tooLongMinutesMilliseconds = config.websocket_minutes_too_long_disconnect * 60 * 1000;
      return timeDifference > tooLongMinutesMilliseconds;
    },
    async websocketConnect() {
      const userId = await this.getUserId();
      this.userId = userId;
      this.wsConnect(userId);
    },
    async getUserId(){
      try{
        const response = await userRepository.getUserId();
        return response.data.user_id;
      }catch (error){
        await this.$store.dispatch("addNotification", {
          text: error.response.data.message,
          time: 6,
          color: "danger"
        });
      }
    },
    wsConnect(userId) {
      const connectedUniqueId = this.generateUniqueId();
      const myWs = new WebSocket(config.websocket_point);

      myWs.onopen = () => {
        myWs.send(JSON.stringify({action: 'newConnection', userId: userId, uniqueId: connectedUniqueId}));
        this.showDanger = false;
        this.showSuccess = true;
        LoggerLibrary.setLog('ws connected');
        if (this.closeConnectTime > 0 && this.tooLongDisconnect(this.closeConnectTime)) {
          this.closeConnectTime = 0;
          LoggerLibrary.setLog('long leave, imitation SaveEnroll event');
          websocketEventBus.saveEnroll({
            "message": "save_enroll",
            "data": {
              "date": this.getDatePhp(),
            },
          });
        }
        setTimeout(() => { this.showSuccess = false; }, 3000);
      };
      myWs.onmessage = (message) => {
        const command = JSON.parse(message.data);
        this.eventBusSend(command);
      };
      myWs.onclose = () => {
        this.showDanger = true;
        // Потому как это событие запускается каждый раз, когда не удалось подключиться
        if (this.closeConnectTime === 0) {
          LoggerLibrary.setLog('ws disconnected');
          this.closeConnectTime = new Date().getTime();
        }
        setTimeout(() => this.websocketConnect(), 5000);
      };
    },
    eventBusSend(message) {
      const currentTime = Date.now();
      const timeSinceBlur = currentTime - this.lastLeaveTime;
      if (+this.lastLeaveTime === 0 || (+this.lastLeaveTime > 0 && timeSinceBlur < this.leaveForImitationEvents)) {
        if (message.message === 'update_notifications') {
          websocketEventBus.updateNotifications(message);
        }else if (message.message === 'save_enroll') {
          LoggerLibrary.setLog('get event: ' +message.message);
          websocketEventBus.saveEnroll(message);
        }else if (message.message === 'delete_enroll') {
          websocketEventBus.deleteEnroll(message);
        }else if (message.message === 'update_balance') {
          websocketEventBus.updateBalance(message);
        }else if (message.message === 'new_support') {
          websocketEventBus.newSupport(message);
        }
      }
    },
    generateUniqueId() {
      return Math.random().toString(36).substring(2);
    }
  },
  created() {
    this.websocketConnect();
  }
};
</script>

<style scoped lang="less">
.websocket--container{
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;

  .websocket--success, .websocket--danger{
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active до версии 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
